import type { RouteRecordRaw, Router } from 'vue-router'

const MissingRoutes: RouteRecordRaw = {
  path: '/claim/missing',
  name: 'MissingModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'MissingMainRoute',
      component: () => import('./views/MissingView.vue'),
      meta: {
        title: 'missing.missingClaims',
      },
    },
    {
      path: 'create',
      name: 'MissingCreateRoute',
      component: () => import('./views/MissingUpsertView.vue'),
      meta: {
        title: 'missing.createMissing',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:missingId',
      name: 'MissingEditRoute',
      component: () => import('./views/MissingUpsertView.vue'),
      meta: {
        title: 'missing.editMissing',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:missingId',
      name: 'ViewMissingRoute',
      component: () => import('./views/SingleMissingView.vue'),
      meta: {
        title: 'missing.ViewMissing',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(MissingRoutes)
}
